import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "creare-page" }
const _hoisted_2 = { class: "hero" }
const _hoisted_3 = { class: "grid" }
const _hoisted_4 = { class: "card" }
const _hoisted_5 = { class: "card-head" }
const _hoisted_6 = { class: "tip-list" }
const _hoisted_7 = {
  key: 0,
  class: "tip-loading"
}
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "tile-name" }
const _hoisted_10 = { class: "card form-card" }
const _hoisted_11 = { class: "card-head" }
const _hoisted_12 = { class: "card-body" }
const _hoisted_13 = {
  key: 0,
  class: "empty"
}
const _hoisted_14 = {
  key: 1,
  class: "succes"
}
const _hoisted_15 = { class: "succes-badge" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { class: "form-desc" }
const _hoisted_18 = { class: "form-grid" }
const _hoisted_19 = {
  key: 2,
  class: "zile-auto g2"
}
const _hoisted_20 = { class: "ml-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[13] || (_cache[13] = _createElementVNode("div", { class: "hero-txt" }, [
        _createElementVNode("div", { class: "hero-eyebrow" }, "PORTAL HR"),
        _createElementVNode("h1", { class: "hero-title" }, "Creare cerere"),
        _createElementVNode("p", { class: "hero-sub" }, "Alege tipul cererii și completează formularul. Cererea intră în fluxul de aprobare.")
      ], -1)),
      _createVNode(_component_v_icon, {
        class: "hero-ic",
        size: "46"
      }, {
        default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
          _createTextVNode("mdi-file-plus-outline", -1)
        ]))]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_v_icon, {
            size: "18",
            color: "#ff5722",
            class: "mr-2"
          }, {
            default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
              _createTextVNode("mdi-format-list-checks", -1)
            ]))]),
            _: 1
          }),
          _cache[15] || (_cache[15] = _createTextVNode("Tip cerere", -1))
        ]),
        _createElementVNode("div", _hoisted_6, [
          (_ctx.loadingTipuri)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createVNode(_component_v_progress_circular, {
                  indeterminate: "",
                  size: "22",
                  color: "#ff5722"
                })
              ]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tipuri, (t) => {
            return (_openBlock(), _createElementBlock("button", {
              key: t.ID,
              type: "button",
              class: _normalizeClass(["tip-tile", { active: t.ID === _ctx.tipSelectatId }]),
              onClick: ($event: any) => (_ctx.selectTip(t.ID))
            }, [
              _createElementVNode("span", {
                class: "tile-ic",
                style: _normalizeStyle({ background: _ctx.metaFor(t.Cod).soft, color: _ctx.metaFor(t.Cod).color })
              }, [
                _createVNode(_component_v_icon, { size: "19" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.metaFor(t.Cod).icon), 1)
                  ]),
                  _: 2
                }, 1024)
              ], 4),
              _createElementVNode("span", _hoisted_9, _toDisplayString(t.Nume), 1),
              (t.ID === _ctx.tipSelectatId)
                ? (_openBlock(), _createBlock(_component_v_icon, {
                    key: 0,
                    size: "18",
                    color: "#ff5722"
                  }, {
                    default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                      _createTextVNode("mdi-check-circle", -1)
                    ]))]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ], 10, _hoisted_8))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          (_ctx.tipCurent)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("span", {
                  class: "fh-ic",
                  style: _normalizeStyle({ background: _ctx.kindMeta.soft, color: _ctx.kindMeta.color })
                }, [
                  _createVNode(_component_v_icon, { size: "16" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.kindMeta.icon), 1)
                    ]),
                    _: 1
                  })
                ], 4),
                _createTextVNode(" " + _toDisplayString(_ctx.tipCurent.Nume), 1)
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createVNode(_component_v_icon, {
                  size: "18",
                  color: "#ff5722",
                  class: "mr-2"
                }, {
                  default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                    _createTextVNode("mdi-pencil-outline", -1)
                  ]))]),
                  _: 1
                }),
                _cache[18] || (_cache[18] = _createTextVNode("Detalii cerere", -1))
              ], 64))
        ]),
        _createElementVNode("div", _hoisted_12, [
          (!_ctx.tipCurent)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createVNode(_component_v_icon, {
                  size: "44",
                  color: "#cbd5e1"
                }, {
                  default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                    _createTextVNode("mdi-gesture-tap-button", -1)
                  ]))]),
                  _: 1
                }),
                _cache[20] || (_cache[20] = _createElementVNode("p", null, "Alege un tip de cerere din stânga pentru a completa formularul.", -1))
              ]))
            : (_ctx.saved)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _createVNode(_component_v_icon, {
                      size: "40",
                      color: "#fff"
                    }, {
                      default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                        _createTextVNode("mdi-check", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _cache[25] || (_cache[25] = _createElementVNode("h3", null, "Cerere trimisă!", -1)),
                  (_ctx.ultimNr)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_16, [
                        _cache[22] || (_cache[22] = _createTextVNode("Număr cerere: ", -1)),
                        _createElementVNode("strong", null, _toDisplayString(_ctx.ultimNr), 1)
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_v_btn, {
                    class: "mt-4 btn-save px-6",
                    onClick: _ctx.resetForm
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, { start: "" }, {
                        default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                          _createTextVNode("mdi-plus", -1)
                        ]))]),
                        _: 1
                      }),
                      _cache[24] || (_cache[24] = _createTextVNode("Cerere nouă", -1))
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]))
              : (_openBlock(), _createBlock(_component_v_form, {
                  key: 2,
                  ref: "formRef"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.kindMeta.desc), 1),
                    _createElementVNode("div", _hoisted_18, [
                      (_ctx.cfg.range)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createVNode(_component_v_text_field, {
                              modelValue: _ctx.f.dataStart,
                              "onUpdate:modelValue": [
                                _cache[0] || (_cache[0] = ($event: any) => ((_ctx.f.dataStart) = $event)),
                                _ctx.calcZile
                              ],
                              type: "date",
                              label: "De la data",
                              variant: "outlined",
                              density: "comfortable",
                              "hide-details": ""
                            }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                            _createVNode(_component_v_text_field, {
                              modelValue: _ctx.f.dataSfarsit,
                              "onUpdate:modelValue": [
                                _cache[1] || (_cache[1] = ($event: any) => ((_ctx.f.dataSfarsit) = $event)),
                                _ctx.calcZile
                              ],
                              type: "date",
                              label: "Până la data (inclusiv)",
                              variant: "outlined",
                              density: "comfortable",
                              "hide-details": ""
                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                          ], 64))
                        : _createCommentVNode("", true),
                      (_ctx.cfg.singleDate)
                        ? (_openBlock(), _createBlock(_component_v_text_field, {
                            key: 1,
                            modelValue: _ctx.f.dataSingle,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.f.dataSingle) = $event)),
                            type: "date",
                            label: "Data",
                            variant: "outlined",
                            density: "comfortable",
                            "hide-details": ""
                          }, null, 8, ["modelValue"]))
                        : _createCommentVNode("", true),
                      (_ctx.cfg.zileAuto)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                            _createVNode(_component_v_icon, {
                              size: "18",
                              color: "#ff5722",
                              class: "mr-2"
                            }, {
                              default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
                                _createTextVNode("mdi-calendar-check", -1)
                              ]))]),
                              _: 1
                            }),
                            _cache[27] || (_cache[27] = _createTextVNode(" Durată: ", -1)),
                            _createElementVNode("strong", _hoisted_20, _toDisplayString(_ctx.f.zileLucratoare), 1),
                            _cache[28] || (_cache[28] = _createTextVNode(" zile lucrătoare ", -1))
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.cfg.oraPlecare)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                            _createVNode(_component_v_select, {
                              modelValue: _ctx.f.oraH,
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.f.oraH) = $event)),
                              items: _ctx.ore24,
                              label: "Ora plecării",
                              variant: "outlined",
                              density: "comfortable",
                              "hide-details": ""
                            }, null, 8, ["modelValue", "items"]),
                            _createVNode(_component_v_select, {
                              modelValue: _ctx.f.oraM,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.f.oraM) = $event)),
                              items: _ctx.minute60,
                              label: "Minute",
                              variant: "outlined",
                              density: "comfortable",
                              "hide-details": ""
                            }, null, 8, ["modelValue", "items"])
                          ], 64))
                        : _createCommentVNode("", true),
                      (_ctx.cfg.durataHM)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                            _createVNode(_component_v_select, {
                              modelValue: _ctx.f.durH,
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.f.durH) = $event)),
                              items: _ctx.ore24,
                              label: "Durată (ore)",
                              variant: "outlined",
                              density: "comfortable",
                              "hide-details": ""
                            }, null, 8, ["modelValue", "items"]),
                            _createVNode(_component_v_select, {
                              modelValue: _ctx.f.durM,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.f.durM) = $event)),
                              items: _ctx.minute60,
                              label: "Minute",
                              variant: "outlined",
                              density: "comfortable",
                              "hide-details": ""
                            }, null, 8, ["modelValue", "items"])
                          ], 64))
                        : _createCommentVNode("", true),
                      (_ctx.cfg.durataOre)
                        ? (_openBlock(), _createBlock(_component_v_text_field, {
                            key: 5,
                            modelValue: _ctx.f.durataOre,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.f.durataOre) = $event)),
                            type: "number",
                            label: "Durată (ore)",
                            variant: "outlined",
                            density: "comfortable",
                            "hide-details": ""
                          }, null, 8, ["modelValue"]))
                        : _createCommentVNode("", true),
                      (_ctx.cfg.tara)
                        ? (_openBlock(), _createBlock(_component_v_text_field, {
                            key: 6,
                            modelValue: _ctx.f.tara,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.f.tara) = $event)),
                            label: "Țara",
                            variant: "outlined",
                            density: "comfortable",
                            "hide-details": ""
                          }, null, 8, ["modelValue"]))
                        : _createCommentVNode("", true),
                      (_ctx.cfg.localitate)
                        ? (_openBlock(), _createBlock(_component_v_text_field, {
                            key: 7,
                            modelValue: _ctx.f.localitate,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.f.localitate) = $event)),
                            label: "Localitate",
                            variant: "outlined",
                            density: "comfortable",
                            "hide-details": ""
                          }, null, 8, ["modelValue"]))
                        : _createCommentVNode("", true),
                      (_ctx.cfg.inlocuitor)
                        ? (_openBlock(), _createBlock(_component_v_select, {
                            key: 8,
                            modelValue: _ctx.f.inlocuitor,
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.f.inlocuitor) = $event)),
                            items: _ctx.inlocuitori,
                            "item-title": "Nume",
                            "item-value": "Id",
                            label: "Înlocuitor",
                            variant: "outlined",
                            density: "comfortable",
                            clearable: "",
                            "hide-details": "",
                            class: "g2",
                            hint: _ctx.inlocuitori.length ? '' : 'Niciun coleg cu cont în departament'
                          }, null, 8, ["modelValue", "items", "hint"]))
                        : _createCommentVNode("", true),
                      _createVNode(_component_v_textarea, {
                        modelValue: _ctx.f.explicatie,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.f.explicatie) = $event)),
                        label: "Explicație",
                        variant: "outlined",
                        density: "comfortable",
                        rows: "3",
                        "hide-details": "",
                        class: "g2"
                      }, null, 8, ["modelValue"])
                    ]),
                    (_ctx.eroare)
                      ? (_openBlock(), _createBlock(_component_v_alert, {
                          key: 0,
                          type: "error",
                          variant: "tonal",
                          density: "compact",
                          class: "mt-4"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.eroare), 1)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_component_v_btn, {
                      block: "",
                      size: "large",
                      class: "btn-save mt-4",
                      loading: _ctx.saving,
                      onClick: _ctx.submit
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, { start: "" }, {
                          default: _withCtx(() => [...(_cache[29] || (_cache[29] = [
                            _createTextVNode("mdi-send", -1)
                          ]))]),
                          _: 1
                        }),
                        _cache[30] || (_cache[30] = _createTextVNode("Trimite cererea ", -1))
                      ]),
                      _: 1
                    }, 8, ["loading", "onClick"])
                  ]),
                  _: 1
                }, 512))
        ])
      ])
    ])
  ]))
}